import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UrlService {
  getBaseUrl(): string {
    return environment.SITE_BASE_URL;
  }

  getClientSiteUrl(uniqueNumber?: string): string {
    const baseUrl = this.getBaseUrl();
    return uniqueNumber
      ? `${baseUrl}/client/site/documents/${uniqueNumber}`
      : `${baseUrl}/client/site`;
  }
}